import React, { Component, Fragment } from "react"
import ReactDOM from "react-dom"
import { pick, difference } from "ramda"
import PropTypes from "prop-types"

import AnnotationsManager from "./annotationsDOMManager.es6"

class AnnotationsArea extends Component {
  annotationsManager = null

  componentDidMount() {
    React.Children.only(this.props.children)

    this.annotationsManager = new AnnotationsManager()
    const container = ReactDOM.findDOMNode(this)
    const settings = this.getManagerSettings(this.props)
    const ids = this.annotationsManager.initialize(container, settings)
    this.props.onInitialize && this.props.onInitialize(ids)
  }

  componentWillUnmout() {
    this.annotationsManager.destroy()
  }

  componentDidUpdate(prevProps) {
    const props = this.props
    if (prevProps.containerClassName !== props.containerClassName) {
      this.annotationsManager.setContainerClassName(props.containerClassName)
    }
    if (prevProps.activeWrapperId !== props.activeWrapperId) {
      props.activeWrapperId
        ? this.annotationsManager.setActiveWrapper(props.activeWrapperId)
        : this.annotationsManager.deactivateWrappers()
    }
    if (prevProps.wrappersIds !== props.wrappersIds) {
      const toRemove = difference(prevProps.wrappersIds, props.wrappersIds)
      this.annotationsManager.removeWrappers(toRemove)
    }
    this.annotationsManager.reInitWrappersHandlers()
    this.annotationsManager.setSettings(this.getManagerSettings(this.props))
  }

  getManagerSettings = (props) =>
    pick(
      [
        "onSelectionEnd",
        "onSelectionClick",
        "onSelectionRightClick",
        "onSelectionMouseEnter",
        "onSelectionMouseLeave",
        "makeId",
        "activeClassName",
        "containerClassName",
        "wrapperClassName",
        "editable",
      ],
      props,
    )

  render() {
    return <Fragment>{this.props.children}</Fragment>
  }
}

AnnotationsArea.propTypes = {
  activeClassName: PropTypes.string,
  activeWrapperId: PropTypes.string,
  containerClassName: PropTypes.string,
  editable: PropTypes.bool,
  makeId: PropTypes.func,
  onInitialize: PropTypes.func,
  onSelectionClick: PropTypes.func,
  onSelectionEnd: PropTypes.func,
  onSelectionMouseEnter: PropTypes.func,
  onSelectionMouseLeave: PropTypes.func,
  onSelectionRightClick: PropTypes.func,
  wrapperClassName: PropTypes.string,
  wrappersIds: PropTypes.arrayOf(PropTypes.string),
}

AnnotationsArea.defaultProps = {
  editable: true,
}

export default AnnotationsArea
